// Helper function to get a value from a possibly nested pathtype NestedObject = {
export interface NestedObject {
  [key: string]:
    | unknown
    | string
    | number
    | boolean
    | Date
    | null
    | undefined
    | NestedObject
    | Array<unknown | string | number | boolean | Date | null | undefined | NestedObject>;
}

// Helper function to get a value from a possibly nested path
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getNestedValue = (obj: any, path: string) => {
  const parts = path.split('.');
  return parts.reduce((acc, part) => (acc && acc[part] !== undefined ? acc[part] : undefined), obj);
};

export default getNestedValue;
